import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from "@nebular/theme";

import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppSettings, environment } from "../../../../environments/environment";
import { EnvConfigService } from "../../../env-config.service";

import { OrderNotificationService } from "../../../@core/services/order-notification.service";
import { SocketService } from "../../../@core/services/socket.service";
// 🔧 REMOVED — import { ProviderNotificationService } from "../../../@core/services/provider-notification.service";


@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<void> = new Subject<void>();

  userPictureOnly: boolean = false;

  logo_url = AppSettings.logo_URL;
  logo_width = AppSettings.logo_width;
  logo_height = AppSettings.logo_height;

  baseUrl = environment.API_ENDPOINT;
  logoUrl: any;
  user: any;
  isDarkMode = false;
  titlename: any;

  userMenu = [
    { title: this.translate.instant("HEADERS.PROFILE") },
    { title: this.translate.instant("HEADERS.LOGOUT") },
  ];

  constructor(
    private readonly envConfig: EnvConfigService,
    private readonly sidebarService: NbSidebarService,
    private readonly menuService: NbMenuService,
    private readonly themeService: NbThemeService,
    private readonly translate: TranslateService,
    private readonly breakpointService: NbMediaBreakpointsService,
    private readonly _auth: AuthService,
    private readonly router: Router,
    private readonly orderNotifService: OrderNotificationService,
    private readonly socketService: SocketService
  ) {
    this.user = JSON.parse(localStorage.getItem("AdminDetails"));

    const logo = this.envConfig.getEnvData();

    console.log(logo, "===================");

    this.titlename = logo.app.name || AppSettings.APPNAME;
    this.logoUrl = this.baseUrl + logo?.app?.logo || AppSettings.logo_URL;

    console.log(this.logoUrl, "Url");
  }

  ngOnInit() {
    // Connect Admin Socket before starting order notification listener
    const adminDetails = JSON.parse(
      localStorage.getItem("AdminDetails") || "{}"
    );

    const userId = adminDetails?._id || adminDetails?.id;

    if (userId) {
      this.socketService.connect(userId, "ADMIN");
    } else {
      console.warn("⚠️ Admin user ID not found. Socket connection skipped.");
    }

    // Start listening for order notifications
    this.orderNotifService.startListening();

    const savedTheme =
      localStorage.getItem("theme") === "default" ||
      localStorage.getItem("theme") === "dark"
        ? localStorage.getItem("theme")
        : "default";

    this.isDarkMode = savedTheme === "dark";
    this.themeService.changeTheme(savedTheme);

    const { xl } = this.breakpointService.getBreakpointsMap();

    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.menuService.onItemClick().subscribe((e) => {
      if (e.item.title === this.translate.instant("HEADERS.LOGOUT")) {
        // localStorage.clear();
        this._auth.logout();
        // localStorage.clear();
      } else if (
        e.item.title === this.translate.instant("HEADERS.PROFILE")
      ) {
        this.router.navigate(["/admin/admin/admin-profile"]);
      }
    });
  }

  handleKeyDown(event: KeyboardEvent): void {
    console.log("Key pressed:", event.key);

    if (event.key === "Enter") {
      this.notificationroute();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();

    return false;
  }

  routring() {
    this.router.navigateByUrl("/admin/expiry-details");
  }

  notificationroute() {
    this.router.navigateByUrl("/admin/notifications");
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;

    const theme = this.isDarkMode ? "dark" : "default";

    this.themeService.changeTheme(theme);

    localStorage.setItem("theme", theme);
  }
}



// import { Component, OnDestroy, OnInit } from "@angular/core";
// import {
//   NbMediaBreakpointsService,
//   NbMenuService,
//   NbSidebarService,
//   NbThemeService,
// } from "@nebular/theme";

// import { map, takeUntil } from "rxjs/operators";
// import { Subject } from "rxjs";
// import { AuthService } from "../../../auth.service";
// import { Router } from "@angular/router";
// import { TranslateService } from "@ngx-translate/core";
// import { AppSettings, environment } from "../../../../environments/environment";
// import { EnvConfigService } from "../../../env-config.service";

// import { OrderNotificationService } from "../../../@core/services/order-notification.service";
// import { SocketService } from "../../../@core/services/socket.service";
// // 🔧 RESTORED — needed again now that this shared header also drives
// // the provider panel's notification bell.
// import { ProviderNotificationService } from "../../../@core/services/provider-notification.service";


// @Component({
//   selector: "ngx-header",
//   styleUrls: ["./header.component.scss"],
//   templateUrl: "./header.component.html",
// })
// export class HeaderComponent implements OnInit, OnDestroy {
//   private readonly destroy$: Subject<void> = new Subject<void>();

//   userPictureOnly: boolean = false;

//   logo_url = AppSettings.logo_URL;
//   logo_width = AppSettings.logo_width;
//   logo_height = AppSettings.logo_height;

//   baseUrl = environment.API_ENDPOINT;
//   logoUrl: any;
//   user: any;
//   isDarkMode = false;
//   titlename: any;

//   // 🔧 NEW — this header is shared by the admin and provider layouts
//   // (it lives under @theme/components, imported into both admin.module.ts
//   // and provider.module.ts). These flags let the template show the
//   // right notification dropdown for whichever panel is actually active.
//   isAdmin = false;
//   isProvider = false;

//   userMenu = [
//     { title: this.translate.instant("HEADERS.PROFILE") },
//     { title: this.translate.instant("HEADERS.LOGOUT") },
//   ];

//   constructor(
//     private readonly envConfig: EnvConfigService,
//     private readonly sidebarService: NbSidebarService,
//     private readonly menuService: NbMenuService,
//     private readonly themeService: NbThemeService,
//     private readonly translate: TranslateService,
//     private readonly breakpointService: NbMediaBreakpointsService,
//     private readonly _auth: AuthService,
//     private readonly router: Router,
//     private readonly orderNotifService: OrderNotificationService,
//     private readonly providerNotifService: ProviderNotificationService, // 🔧 NEW
//     private readonly socketService: SocketService
//   ) {
//     // 🔧 CHANGED — read both storage keys so this constructor works
//     // no matter which panel loaded the header. Whichever one exists
//     // determines `this.user` (used for the nb-user avatar/name).
//     const adminDetails = JSON.parse(
//       localStorage.getItem("AdminDetails") || "null"
//     );
//     const providerDetails = JSON.parse(
//       localStorage.getItem("ProviderDetails") || "null"
//     );

//     this.user = adminDetails || providerDetails;

//     const logo = this.envConfig.getEnvData();

//     console.log(logo, "===================");

//     this.titlename = logo.app.name || AppSettings.APPNAME;
//     this.logoUrl = this.baseUrl + logo?.app?.logo || AppSettings.logo_URL;

//     console.log(this.logoUrl, "Url");
//   }

//   ngOnInit() {
//     // 🔧 CHANGED — branch on whichever panel's user details actually
//     // exist in localStorage, connect the socket with the matching role,
//     // and start only the matching notification service. This replaces
//     // the old admin-only block.
//     const adminDetails = JSON.parse(
//       localStorage.getItem("AdminDetails") || "null"
//     );
//     const providerDetails = JSON.parse(
//       localStorage.getItem("ProviderDetails") || "null"
//     );

//     if (adminDetails) {
//       this.isAdmin = true;

//       const userId = adminDetails?._id || adminDetails?.id;

//       if (userId) {
//         this.socketService.connect(userId, "ADMIN");
//       } else {
//         console.warn("⚠️ Admin user ID not found. Socket connection skipped.");
//       }

//       this.orderNotifService.startListening();

//     } else if (providerDetails) {
//       this.isProvider = true;

//       const userId = providerDetails?._id || providerDetails?.id;

//       if (userId) {
//         this.socketService.connect(userId, "PROVIDER");
//       } else {
//         console.warn("⚠️ Provider user ID not found. Socket connection skipped.");
//       }

//       this.providerNotifService.startListening();

//     } else {
//       console.warn("⚠️ Neither AdminDetails nor ProviderDetails found. Socket connection skipped.");
//     }

//     const savedTheme =
//       localStorage.getItem("theme") === "default" ||
//       localStorage.getItem("theme") === "dark"
//         ? localStorage.getItem("theme")
//         : "default";

//     this.isDarkMode = savedTheme === "dark";
//     this.themeService.changeTheme(savedTheme);

//     const { xl } = this.breakpointService.getBreakpointsMap();

//     this.themeService
//       .onMediaQueryChange()
//       .pipe(
//         map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
//         takeUntil(this.destroy$)
//       )
//       .subscribe(
//         (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
//       );

//     this.menuService.onItemClick().subscribe((e) => {
//       if (e.item.title === this.translate.instant("HEADERS.LOGOUT")) {
//         // localStorage.clear();
//         this._auth.logout();
//         // localStorage.clear();
//       } else if (
//         e.item.title === this.translate.instant("HEADERS.PROFILE")
//       ) {
//         this.router.navigate(["/admin/admin/admin-profile"]);
//       }
//     });
//   }

//   handleKeyDown(event: KeyboardEvent): void {
//     console.log("Key pressed:", event.key);

//     if (event.key === "Enter") {
//       this.notificationroute();
//     }
//   }

//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

//   toggleSidebar(): boolean {
//     this.sidebarService.toggle(true, "menu-sidebar");

//     return false;
//   }

//   navigateHome() {
//     this.menuService.navigateHome();

//     return false;
//   }

//   routring() {
//     this.router.navigateByUrl("/admin/expiry-details");
//   }

//   notificationroute() {
//     this.router.navigateByUrl("/admin/notifications");
//   }

//   toggleTheme(): void {
//     this.isDarkMode = !this.isDarkMode;

//     const theme = this.isDarkMode ? "dark" : "default";

//     this.themeService.changeTheme(theme);

//     localStorage.setItem("theme", theme);
//   }
// }